import React from "react";

/**
 * Mara Padel League — official image logo (extracted from brand PDF).
 * Always rendered on a white background per brand guidelines.
 * Variants:
 *   - default  : standard image logo on white plate
 *   - inline   : compact horizontal version for nav bars
 *   - bare     : image alone (no white plate) for placements that already sit on white
 */
const LOGO_SRC = "/assets/mara-logo-pdf.png";

export function Logo({ className = "h-12", variant = "default" }) {
  if (variant === "bare") {
    return (
      <img
        src={LOGO_SRC}
        alt="Mara Padel League"
        data-testid="mara-logo"
        className={`object-contain ${className}`}
      />
    );
  }
  if (variant === "inline") {
    return (
      <div
        data-testid="mara-logo"
        className={`inline-flex items-center bg-white rounded-md shadow-sm px-2 py-1 ${className}`}
      >
        <img src={LOGO_SRC} alt="Mara Padel League" className="h-full w-auto object-contain" />
      </div>
    );
  }
  return (
    <div
      data-testid="mara-logo"
      className={`inline-flex items-center bg-white rounded-lg shadow-md px-3 py-2 ${className}`}
    >
      <img src={LOGO_SRC} alt="Mara Padel League" className="h-full w-auto object-contain" />
    </div>
  );
}

/** Backwards-compatible mark — uses the same image so visuals stay consistent. */
export function LogoMark({ className = "h-10" }) {
  return (
    <div className={`inline-flex items-center bg-white rounded-md p-1 ${className}`}>
      <img src={LOGO_SRC} alt="Mara Padel League" className="h-full w-auto object-contain" />
    </div>
  );
}

export function KenyaStripe({ className = "" }) {
  return <div className={`kenya-stripe-thin ${className}`} data-testid="kenya-stripe" />;
}
